
import { useState } from "react";
import { EnrichedVisitor } from "@/types/database";
import { exportVisitorsToCSV } from "@/utils/exportUtils";

export const useVisitorSelection = (allVisitors: EnrichedVisitor[]) => {
  const [selectedVisitors, setSelectedVisitors] = useState<Set<string>>(new Set());

  const togglePage = (pageVisitors: EnrichedVisitor[]) => {
    // Check if all current page visitors are selected
    const allSelected = pageVisitors.every(visitor => selectedVisitors.has(visitor.id));
    
    const newSelected = new Set(selectedVisitors);
    
    if (allSelected) {
      // Unselect all visitors on the current page
      pageVisitors.forEach(visitor => newSelected.delete(visitor.id));
    } else {
      // Select all visitors on the current page
      pageVisitors.forEach(visitor => newSelected.add(visitor.id));
    }
    
    setSelectedVisitors(newSelected);
  };

  const toggleVisitor = (id: string) => {
    const newSelected = new Set(selectedVisitors);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedVisitors(newSelected);
  };

  const exportToCSV = (visitors: EnrichedVisitor[]) => {
    exportVisitorsToCSV(visitors, selectedVisitors);
  };

  return {
    selectedVisitors,
    togglePage,
    toggleVisitor,
    exportToCSV,
    clearSelection: () => setSelectedVisitors(new Set())
  };
};
